import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { logout } from "store/auth/auth.slice";
import { User, USER_TYPE } from "types";

const initialState: User = {
  id: 0,
  name: "",
  email: "",
  phone_number: "",
  stripe_customer_id: "",
  user_type: USER_TYPE.UNDEFINED,
  user_find_score: 0,
  alerts_selected: 0,
  alerts_activity_attend: 0,
  alerts_activity_cancel: 0,
  alerts_activity_other: 0,
  alerts_idol_latest: 0,
  alerts_follower_added: 0,
  alerts_follow_other: 0,
  created_at: "",
  updated_at: "",
  banner_image_url: "",
  blocked: {
    blocked: [],
    blocked_by: [],
  },
  templateType: "",
  templateModel: {
    id: 0,
    user_id: 0,
    myself_type: "",
    created_at: "",
    updated_at: "",
  },
  bio_description: "",
  socialAvatarUrl: "",
  location: "",
  reset_expiration: "",
  reset_key: "",
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    updateUser: (state, action: PayloadAction<Partial<User>>) => ({
      ...state,
      ...action.payload,
    }),
  },
  extraReducers: (builder) => {
    builder.addCase(logout, () => initialState); // reset al desloguear
  },
});

export const { updateUser } = userSlice.actions;

export default userSlice.reducer;
